import { HTMLAttributes, type JSX } from "react"
import classNames from "classnames"
import { ToggleSwitch } from "@nova/component-toggle-switch"

type InspectorPanelKeyValueToggleProps = {
    keyTitle: string
    isToggled: boolean
    setIsToggled: (isToggled: boolean) => void
    toggleClassName?: string
    titleClassName?: string
    disabled?: boolean
    Tag?: keyof JSX.IntrinsicElements
}

export const InspectorPanelKeyValueToggle = ({
    keyTitle,
    isToggled,
    setIsToggled,
    className,
    toggleClassName,
    titleClassName,
    disabled,
    Tag = "h5",
    ...rest
}: InspectorPanelKeyValueToggleProps & HTMLAttributes<HTMLDivElement>) => {
    return (
        <div
            className={classNames("flex-none flex items-center h-8 relative", className)}
            {...rest}
        >
            {/* Key & Switch */}
            <div className={classNames("flex gap-3 items-center w-full", toggleClassName)}>
                {/* Field Key */}
                <Tag
                    className={classNames(
                        "text-gray-0 select-none flex-none w-max normalLineHeight",
                        titleClassName
                    )}
                >
                    {keyTitle}
                </Tag>

                {/* Switch */}
                <ToggleSwitch
                    isToggled={isToggled}
                    setIsToggled={setIsToggled}
                    disabled={disabled}
                />
            </div>
        </div>
    )
}
